import React from "react";
import { Button, Modal } from "@mantine/core";

const TimerWarning = (props) => {
  const { isOpenModal, language } = props;

  const goBackUrl = localStorage.getItem("goBackUrl");
  const isBooking = goBackUrl && goBackUrl.includes("booking");
  const isShop = goBackUrl && goBackUrl.includes("ticketshop");

  const navigateBack = () => {
    const referrerPathname = document.referrer.split("/")?.[3];
    if (goBackUrl) {
      window.location.href = goBackUrl;
    } else if (referrerPathname === "") {
      window.location = `${document.referrer}ticketshop`;
    } else {
      window.location = document.referrer;
    }
  };

  return (
    <Modal
      opened={isOpenModal}
      title={language ? language.Information : "Information"}
      withCloseButton={false}
    >
      <div>
        <p>
          {isShop &&
            (language.Article_Expired
              ? language.Article_Expired
              : "Reservationstiden för ditt köp har utgått och din varukorg har uppdaterats. Klicka på knappen för att gå tillbaka till butiken. Kontrollera din varukorg och försök igen.")}
          {isBooking && language.Booking_Expired}
        </p>
      </div>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button className="primaryButton" onClick={navigateBack}>
          {language && isShop && language.Back_To_Shop}
          {language && isBooking && language.Back_To_Booking}
        </Button>
      </div>
    </Modal>
  );
};

export default TimerWarning;
